import { Box, Container, Stack, useTheme } from '@mui/material';
import { ReactNode } from 'react';

type DesktopHeaderProps = {
    rightNode: ReactNode;
    leftNode?: ReactNode;
    centerNode: ReactNode;
    children: ReactNode;
};

export function DesktopHeader({ leftNode, centerNode, rightNode, children }: DesktopHeaderProps) {
    const theme = useTheme();

    // This header doesn't use the AppBar and Toolbar Component as it needs to be wider than 1200px
    return (
        <Box sx={{ backgroundColor: theme.palette.background.paper }}>
            <Container
                maxWidth="xl"
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: 2,
                    paddingBottom: 3.5,
                }}
            >
                <Box sx={{
                    flexBasis: 0,
                    flexGrow: 1,
                }}
                >
                    {leftNode}
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexBasis: 0,
                    flexGrow: 1,
                    marginTop: 4.5,
                }}
                >
                    {centerNode}
                </Box>
                <Stack sx={{
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    flexBasis: 0,
                    flexGrow: 1,
                    gap: 1,
                }}
                >
                    {rightNode}
                </Stack>
            </Container>
            {children}
        </Box>
    );
}
